import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';

import colors from '@general/colors';
import MagnifyingGlassIcon from '@icons/MagnifyingGlassIcon';

const InputStyled = styled.input`
    border: 1px solid ${colors.lightGray};

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.darkGray};
    }
`;

const SubmitButtonStyled = styled.button`
    position: absolute;
    bottom: 0;
    right: 0;
    height: 54px;
    width: 54px;
    background-color: ${colors.azure};
`;

const AnnouncementsSearchBox = ({ currentRefinement, refine }) => {
    const [textValue, setTextValue] = useState(currentRefinement || '');
    const applyQuery = useDebouncedCallback(async searchTerm => {
        refine(searchTerm);
    }, 400);

    return (
        <div style={{ position: 'relative' }}>
            <InputStyled
                className="form-control p-3"
                autoComplete="off"
                placeholder="Search announcements"
                value={textValue}
                onChange={e => {
                    const newValue = e.target.value;
                    setTextValue(newValue);
                    applyQuery(newValue);
                }}
            />

            <SubmitButtonStyled type="submit" title="Submit your search query." className="ais-SearchBox-submit">
                <MagnifyingGlassIcon size={20} />
            </SubmitButtonStyled>
        </div>
    );
};

AnnouncementsSearchBox.propTypes = {
    currentRefinement: PropTypes.string,
    refine: PropTypes.func.isRequired,
};

export default connectSearchBox(AnnouncementsSearchBox);
